export enum FieldName {
    Title = "title",
    Status = "status",
    Category = "category",
    Criticality = "criticality",
    FromDate = "fromDate",
    ToDate = "toDate",
    EstimatedDowntime = "estimatedDowntime",
    ExternalReference = "externalReference",
    Responsible = "responsible",
    Deviation = "deviation",
    Description = "description",
    NextFollowup = "nextFollowup",
    Checklist = "checklist",
    ETag = "eTag",
    PostId = "postId",
    PostedOn = "postedOn",
    PostedBy = "postedBy",
    Content = "content",
    Id = "id",
    Name = "name",
    CustomerNumber = "customerNumber",
    CustomerName = "customerName",
    CustomerType = "customerType",
    CustomerSalesforceId = "customerSalesforceId",
    AddressIds = "addressIds",
    AddressId = "addressId",
    ConnectionNumbers = "connectionNumbers",
    GisApiLocation = "gisApiLocation",
}

export enum EditableFieldsDate {
    startTimeDate     = '@startTimeDate',
    endTimeDate       = '@endTimeDate',
    nextFollowupDate  = '@nextFollowupDate',
    solvedWithinDate  = '@solvedWithinDate',
}

export enum EditableFieldsString {
    startTimeFree     = '@startTimeFree',
    endTimeFree       = '@endTimeFree',
    caseNumber        = '@caseNumber',
    downTime          = '@downTime',
    affectedServices  = '@affectedServices',
    customerName      = '@customerName',
    customerAddress   = '@customerAddress',
    article           = '@article',
    connectionNumber  = '@connectionNumber',
}

export enum AlertSelectionCards {
    companyCustomerIds         = "companyCustomerIds",
    privateCustomerIds         = "privateCustomerIds",
    companyWithSlaCustomerIds  = "companyWithSlaCustomerIds",
    phoneNumbers               = "phoneNumbers",
    emailAddresses             = "emailAddresses",
    allCompanyCustomers             = "allCompanyCustomers",
}

export const accordionVisible = {
    "Detaljer": true,
    "Berørte": true,
    "Varsler": true,
    "Kart": true,
    "Diskusjon": true,
    "Sjekkliste": true,
    "Dokumenter": true,
    "Oppdrag": true,
};

export const dataGridColumnVisible = {
    id: true,
    externalReference: false,
    status: true,
    category: false,
    criticality: false,
    title: true,
    responsible: true,
    fromDate: true,
    toDate: true,
    createdOn: true,
    closedDate: false,
}

export const documentGridColumnVisible = {
    comment: false,
}
    